/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const ref_number_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeWidth={1.5}
      d="M22 3H2a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1Z"
    />
    <path
      fill="#000"
      d="M7.386 15h1.566l-1.341-2.556c.801-.252 1.251-.882 1.251-1.809 0-1.224-.792-1.935-2.151-1.935H4.2V15h1.35v-2.43h.675L7.386 15ZM5.55 9.78h.945c.684 0 .999.27.999.855s-.315.855-.999.855H5.55V9.78Zm8.667 0V8.7h-3.87V15h3.87v-1.08h-2.52V12.4h2.16v-1.08h-2.16V9.78h2.52Zm5.559 0V8.7h-3.87V15h1.35v-2.6h2.16v-1.08h-2.16V9.78h2.52Z"
    />
  </svg>
)
export default ref_number_medium
